const stateColors = {
  draft: "amber",
  open: "sky",
  close: "lime",
};

function getView() {
  return {
    model: "crm.customer_service",
    form_action: ["save", "edit", "add"],
    table_action: ["edit", "add"],
    activeSearch: true,
    domain: [],
    softDomain: [["id", ">", 0]],
    tags: { state: stateColors },
    fields: {
      number: { type: "char", searchable: true, readOnly: true },
      state: { type: "char", readOnly: true },
      party: { type: "many2one", model: "party.party" },
      customer: { type: "char" },
      address: { type: "char" },
      phone: { type: "char" },
      city: { type: "char" },
      case: { type: "many2one", model: "crm.case" },
      media: { type: "selection" },
      description: { type: "text" },
      diagnose: { type: "text" },
      response: { type: "text" },
      cs_date: { type: "datetime", formatString: "YYYY-MM-DD HH:mm", readOnly: true },
      effective_date: { type: "datetime", formatString: "YYYY-MM-DD HH:mm" },
      satisfaction: { type: "selection" },
      efficacy: { type: "selection" },
      responsible_employee: { type: "many2one", model: "company.employee" },
      department: { type: "many2one", model: "company.department" },
      notes: { type: "text" },
      action_plan: { type: "text" },
      category_customer: { type: "many2one", model: "party.category" },
    },
    list: [
      { name: "number", width: "15%" },
      { name: "state", width: "10%" },
      { name: "party", width: "20%" },
      { name: "customer", width: "15%" },
      { name: "cs_date", width: "15%" },
      { name: "case", width: "20%" },
    ],
    form: [
      { name: "party" },
      { name: "customer" },
      { name: "number" },
      { name: "state" },
      { name: "cs_date" },
      { name: "effective_date" },
      { name: "case" },
      { name: "media" },
      { name: "address" },
      { name: "phone" },
      { name: "city" },
      { name: "description", colSpan: "md:col-span-2" },
      { name: "diagnose", colSpan: "md:col-span-2" },
      { name: "response", colSpan: "md:col-span-2" },
      { name: "satisfaction" },
      { name: "efficacy" },
      { name: "responsible_employee" },
      { name: "department" },
      { name: "category_customer" },
      { name: "notes", colSpan: "md:col-span-2" },
      { name: "action_plan", colSpan: "md:col-span-2" },
    ],
  };
}

export default { ctxView: getView };
